<template>
  <div id="home">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :color="color"
      :opacity="1"
      :is-full-page="fullPage"
    ></loading>
    <div class="navbar bg-transparent justify-content-end" v-if="isFinished">
      <button type="button" class="btn btn-outline-light" :disabled="isClient">
        <div style="font-size:15px">
          <img :src="profileImg" width="25" height="25" class="rounded-circle" />
          Welcome Back {{displayName}}
        </div>
      </button>
    </div>
    <div class="container center-content">
      <div class="row">
        <div class="col-sm dashboard-text-control" style="padding-bottom:50px">
          <h2>
            <b>DASHBOARD</b>
          </h2>
        </div>
        <div class="w-100"></div>
        <div class="col-sm text-control">
          <div class="shadow p-3 mb-5 round first">
            <h5>OXYGEN</h5>
            <h1>
              <b>{{oxygen}}</b>
            </h1>
            <p>mmHg</p>
          </div>
        </div>
        <div class="col-sm text-control">
          <div class="shadow p-3 mb-5 round second">
            <h5>HEARTH RATE</h5>
            <h1>
              <b>{{heart_rate}}</b>
            </h1>
            <p>BPM</p>
          </div>
        </div>
        <div class="col-sm text-control">
          <div class="shadow p-3 mb-5 round third">
            <h5>TEMPERATURE</h5>
            <h1>
              <b>{{temp}}</b>
            </h1>
            <p>°C</p>
          </div>
        </div>
        <!-- <div class="w-100"></div>
        <div class="col text-control">
          <div class="shadow p-3 mb-5 round bg-dark">
           
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
const firebaseApp = require("../firebase.js");
const line = require("../line-config");
export default {
  data() {
    return {
      lineId: null,
      cid: null,
      color: "#d8737f",
      onCancel: true,
      displayName: null,
      isFinished: false,
      isLoading: false,
      fullPage: true,
      isClient: false,
      oxygen: 0,
      heart_rate: 0,
      temp: 0,
      profileImg: "https://mdbootstrap.com/img/Photos/Avatars/img%20(31).jpg"
    };
  },
  mounted() {
    const liff = this.$liff;
    this.isLoading = true;
    liff
      .init({
        liffId: line.liffID
      })
      .then(() => {
        this.isClient = liff.isInClient();
        if (liff.isInClient()) {
          this.isClient = true;
        }
        if (location.origin == "http://localhost:8080") {
          console.log(location.origin);
          firebaseApp.usersCollection
            .where("lineID", "==", "Ucd4364661653656f90ff89c39a3b6494")
            .get()
            .then(snap => {
              // console.log(snap.empty);
              if (!snap.empty) {
                // eslint-disable-next-line no-unused-vars
                snap.forEach(async doc => {
                  this.cid = "akihitoq";
                  this.isLoading = false;
                  this.isFinished = true;
                  // eslint-disable-next-line no-unused-vars
                  await firebaseApp.caring_box
                    .where("payload.usr", "==", this.cid)
                    .get()
                    .then(async snap => {
                      if (!snap.empty) {
                        const datas = [];
                        snap.forEach(async doc => {
                          datas.push(doc.data().payload);
                          // this.temp = doc.data().sensors[1].data;
                          // this.heart_rate = doc.data().sensors[3].value;
                          // this.oxygen = doc.data().sensors[2].value;
                        });
                      }
                    });
                });
              } else {
                this.$router.push({ path: "/register" });
              }
            });
          this.isLoading = false;
          this.isFinished = true;
        } else {
          if (liff.isLoggedIn()) {
            liff
              .getProfile()
              .then(profile => {
                // console.log(profile);
                firebaseApp.usersCollection
                  .where("lineID", "==", profile.userId)
                  .get()
                  .then(snap => {
                    // console.log(snap.empty);
                    if (!snap.empty) {
                      snap.forEach(async doc => {
                        // console.log(doc.data())
                        this.profileImg = await profile.pictureUrl;
                        this.lineId = await profile.userId;
                        this.displayName = await profile.displayName;
                        this.cid = await doc.data().username;
                        this.isLoading = false;
                        this.isFinished = true;
                        // eslint-disable-next-line no-unused-vars
                        await firebaseApp.caring_box
                          .where("payload.usr", "==", this.cid)
                          .get()
                          .then(async snap => {
                            const datas = [];
                            if (!snap.empty) {
                              snap.forEach(async doc => {
                                // console.log(doc.data());
                                await datas.push(doc.data().payload);
                              });
                              const new_array = datas.sort(this.compare_qty);
                              // console.log(new_array);
                              this.temp = new_array[new_array.length - 1].sensors[0].data;
                              this.heart_rate = new_array[new_array.length - 1].sensors[2].value;
                              this.oxygen = new_array[new_array.length - 1].sensors[1].value;
                            } else {
                              console.log('no data')
                            }
                          });
                      });
                    } else {
                      this.$router.push({ path: "/register" });
                    }
                  });
              })
              .catch(err => {
                console.error(err);
              });
          } else {
            console.log("LIFF is not logged in");
            liff.login();
          }
        }
      });
  },
  methods: {
    compare_qty: function(a, b) {
      // a should come before b in the sorted order
      if (a.timestamp < b.timestamp) {
        return -1;
        // a should come after b in the sorted order
      } else if (a.qty > b.qty) {
        return 1;
        // a and b are the same
      } else {
        return 0;
      }
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #475c7a;
  color: #ffffff;
  height: 100%;
  margin: 0;
}
#home {
}

h2 {
  text-shadow: 0 6px 1px rgba(0, 0, 0, 0.1), 0 0 5px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.3), 0 3px 5px rgba(0, 0, 0, 0.2),
    0 5px 10px rgba(0, 0, 0, 0.25);
}

.btn-outline-light {
  border-radius: 40px;
}

.dashboard-text-control {
  padding-bottom: 20px;
}

.center-content {
  padding-top: 20vh;
  @media (max-width: 767.98px) {
    padding-top: 7vh;
  }
}

.text-control {
  text-align: center;
}

.round {
  border-radius: 25px;
}

.first {
  background-color: #fcbb6d;
}

.second {
  background-color: #d8737f;
}

.third {
  background-color: #568ea6;
}
button:focus {
  outline: none;
}

*:focus {
  outline: none;
}

[class*="col-"] {
  margin-bottom: -30px;
}
</style>
